import PropTypes from 'prop-types';

import PromoImageBanner from '../../../Banners/PromoImageBanner';
import PointsTile from '../../../Cards/PointsTile';

import { SectionWrapper, CardContainers } from './styles';

const PointsSection = ({ data }) => {
  if (!data) return null;

  const { elements } = data;

  const imageBanner = elements.find(
    el => el.component === 'points-hero-banner',
  );

  const cardElements = elements.filter(
    el => el.component !== 'points-hero-banner',
  );

  return (
    <SectionWrapper>
      <PromoImageBanner data={imageBanner} />
      <CardContainers>
        {cardElements &&
          cardElements.map(card => (
            <PointsTile key={card.id} className="points-section" data={card} />
          ))}
      </CardContainers>
    </SectionWrapper>
  );
};

PointsSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PointsSection;
